<template>
    <p></p>
</template>
<script setup lang="ts">
import { useHead } from "@unhead/vue";

useHead({
  templateParams: {
    separator: "-",
  },
  title: "Bella da Semana %subTitle",
  titleTemplate: "%s %separator %subPage",
  meta: [
    {
      name: "robots",
      content: "All",
    },
    {
      name: "theme-color",
      content: "#fff",
    },
    {
      name: "author",
      content: "Bella da Semana",
    },
    {
      name: "copyright",
      content:
        "&copy; 2001 - " + new Date().getFullYear() + ". Bella Entretenimento Ltda.",
    },
    {
      name: "title",
      content: "%s %separator %subPage",
    },
    {
      name: "identifier-url",
      content: "%page_url",
    },
    {
      name: "description",
      content: "%page_description",
    },
    {
      name: "keywords",
      content: "%page_keywords",
    },
    {
      name: "googlebot",
      content:
        "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
    },
    {
      name: "bingbot",
      content:
        "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
    },
    {
      name: "twitter:card",
      content: "summary",
    },
    {
      name: "twitter:site",
      content: "@belladasemana",
    },
    {
      name: "twitter:title",
      content: "%s %separator %subPage",
    },
    {
      name: "twitter:description",
      content: "%page_description",
    },
    {
      name: "twitter:image",
      content: "%page_image",
    },
    {
      property: "og:title",
      content: "%s %separator %subPage",
    },
    {
      property: "og:description",
      content: "%page_description",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:image",
      content: "%page_image",
    },
    {
      property: "og:image:type",
      content: "image/jpeg",
    },
    {
      property: "og:image:width",
      content: "500",
    },
    {
      property: "og:image:height",
      content: "500",
    },
    {
      property: "og:url",
      content: "%page_url",
    },
    {
      property: "og:site_name",
      content: "%s",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "%page_canonical",
    },
    {
      rel: "alternate",
      hreflang: "en",
      href: "%page_url_en"
    },
    {
      rel: "alternate",
      hreflang: "pt-br",
      href: "%page_url_pt"
    },
  ],
  htmlAttrs: {
    lang: "%page_locale"
  }
});
</script>
